import { trackLoyaltyCreditCardApplyNowClick, type LoyaltyCreditCardApplyNowPlacement } from 'analytics/snowplow/events/loyaltyCreditCardEvents'
import TextButton from 'LuxKit/Button/TextButton'
import { useLoyaltyCreditCardApplyUrl } from 'loyalty/hooks/useLoyaltyCreditCardApplyUrl'
import { useCallback, type ComponentProps, type ReactNode } from 'react'
import { useIntl } from 'react-intl'

interface Props {
  children?: ReactNode
  className?: string
  fit?: ComponentProps<typeof TextButton>['fit']
  placement: LoyaltyCreditCardApplyNowPlacement
}

function LoyaltyCreditCardApplyNowButton({ children, className, fit, placement }: Props) {
  const intl = useIntl()
  const applyUrl = useLoyaltyCreditCardApplyUrl()
  const handleClick = useCallback(() => {
    trackLoyaltyCreditCardApplyNowClick(placement)
  }, [placement])

  return (
    <TextButton
      kind="primary"
      shape="round"
      size="medium"
      href={applyUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      fit={fit}
      onClick={handleClick}
    >
      {children ?? intl.formatMessage({
        id: 'opPvWiIiZ4hja1C1IaRO',
        defaultMessage: 'Apply now',
        description: 'Primary CTA on the Société Credit Card landing page',
      })}
    </TextButton>
  )
}

export default LoyaltyCreditCardApplyNowButton
